var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.599976 1.99999C0.599976 1.33725 1.13723 0.799988 1.79998 0.799988H16.2C16.8627 0.799988 17.4 1.33725 17.4 1.99999C17.4 2.66273 16.8627 3.19999 16.2 3.19999H1.79998C1.13723 3.19999 0.599976 2.66273 0.599976 1.99999Z",
    fill: "#53545C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.599976 7.99999C0.599976 7.33725 1.13723 6.79999 1.79998 6.79999H16.2C16.8627 6.79999 17.4 7.33725 17.4 7.99999C17.4 8.66273 16.8627 9.19999 16.2 9.19999H1.79998C1.13723 9.19999 0.599976 8.66273 0.599976 7.99999Z",
    fill: "#53545C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79998 14C7.79998 13.3372 8.33723 12.8 8.99998 12.8H16.2C16.8627 12.8 17.4 13.3372 17.4 14C17.4 14.6627 16.8627 15.2 16.2 15.2H8.99998C8.33723 15.2 7.79998 14.6627 7.79998 14Z",
    fill: "#53545C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.b8b17fbe9e7c26768f37608b956d6515.svg";
export { ForwardRef as ReactComponent };